export const AcceptOfferInvalidParametersError: Error = new Error('Invalid parameters for accepting an offer');
export const AcceptOfferTokensListError: Error = new Error('Failed to retrieve tokens list from api');
export const AcceptOfferAssetError: Error = new Error('Failed to retrieve asset from api');
export const AcceptOfferOrderError: Error = new Error('Failed to retrieve order from api');
export const AcceptOfferAcceptOrderAPIError: Error = new Error('Failed to accept offer in api');
